import { Skeleton } from "@chakra-ui/react";
import React from "react";
import { GenericError } from "src/components/Feedback/GenericError";
import { MultiSelectInput } from "src/components/Inputs/MultiSelectInput";
import { RemoteDataView } from "src/components/Layout/RemoteDataView";
import { HighlightedText } from "src/components/Text/HighlightedText";
import { GetSchoolsByEnrollmentPeriodResponse } from "src/generated/hooks/form-service/requests";
import { useGlossary } from "src/hooks/useGlossary";
import * as RD from "src/types/remoteData";

export type School = {
  id: string;
  name: string;
};
type Props = {
  remoteData: RD.RemoteData<unknown, GetSchoolsByEnrollmentPeriodResponse>;
  onChange: (schools: School[] | null) => void;
  selectedSchools: School[];
};
export const SchoolsMultiSelectInput: React.FC<Props> = ({
  remoteData,
  onChange,
  selectedSchools,
}) => {
  const { glossary } = useGlossary();
  return (
    <RemoteDataView
      error={() => <GenericError variant="inline" />}
      remoteData={remoteData}
      loading={<Skeleton height="1rem" width="200px" />}
    >
      {(schools) => (
        <MultiSelectInput
          variant="check"
          leftIcon={null}
          selectAllItem={{ enable: true, text: glossary`All schools` }}
          options={schools.data}
          placeholder={glossary`Select schools`}
          labelAttr="name"
          label={undefined}
          onChange={(newSchools: School[]) => {
            if (newSchools.length === schools.data.length) {
              // all schools
              onChange(null);
            } else {
              onChange(newSchools);
            }
          }}
          selectedItems={selectedSchools}
          renderDropdownItem={(option, keyword) => (
            <HighlightedText text={option.name} keyword={keyword} invert />
          )}
          size="md"
        />
      )}
    </RemoteDataView>
  );
};
